/**
 * SEO constants for the website
 * Contains default metadata for all pages and specific metadata for each page
 */

// Base domain for canonical URLs
export const BASE_URL = 'https://domiktyumen.ru';

// Default metadata
export const DEFAULT_SEO = {
  title: 'DomikTyumen - Аренда недвижимости в Тюмени',
  description: 'Аренда квартир, домов и коттеджей в Тюмени. Большой выбор недвижимости для комфортного проживания.',
  keywords: 'аренда, недвижимость, Тюмень, квартиры, дома, коттеджи, посуточно',
  ogImage: '/assets/og-image.jpg',
};

// Page specific metadata
export const PAGE_SEO = {
  home: {
    title: 'DomikTyumen - Главная | Аренда недвижимости в Тюмени',
    description: 'Аренда квартир, домов и коттеджей в Тюмени. Выбирайте из нашего каталога недвижимости для комфортного проживания.',
    keywords: 'аренда, недвижимость, Тюмень, квартиры, дома, коттеджи, посуточно, главная',
    path: '/',
  },
  gallery: {
    title: 'DomikTyumen - Галерея объектов недвижимости в Тюмени',
    description: 'Фотогалерея квартир, домов и коттеджей для аренды в Тюмени. Просмотрите фотографии и выберите подходящий вариант.',
    keywords: 'галерея, фото недвижимости, аренда, Тюмень, квартиры, дома, коттеджи',
    path: '/gallery',
  },
  booking: {
    title: 'DomikTyumen - Забронировать недвижимость в Тюмени',
    description: 'Бронирование квартир, домов и коттеджей в Тюмени. Выберите даты и забронируйте подходящий вариант.',
    keywords: 'бронирование, аренда, недвижимость, Тюмень, квартиры, дома, коттеджи',
    path: '/booking',
  },
  videos: {
    title: 'DomikTyumen - Видеообзоры недвижимости в Тюмени',
    description: 'Видеообзоры квартир, домов и коттеджей для аренды в Тюмени. Посмотрите видео и выберите подходящий вариант.',
    keywords: 'видео, обзоры, аренда, недвижимость, Тюмень, квартиры, дома, коттеджи',
    path: '/videos',
  },
  testimonials: {
    title: 'DomikTyumen - Отзывы клиентов об аренде недвижимости в Тюмени',
    description: 'Отзывы клиентов о нашей компании и арендуемой недвижимости в Тюмени. Узнайте мнение тех, кто уже воспользовался нашими услугами.',
    keywords: 'отзывы, аренда, недвижимость, Тюмень, квартиры, дома, коттеджи, клиенты, мнения',
    path: '/testimonials',
  },
  about: {
    title: 'DomikTyumen - О нас | Аренда недвижимости в Тюмени',
    description: 'Информация о компании DomikTyumen. Узнайте больше о нашей компании, предоставляющей услуги по аренде недвижимости в Тюмени.',
    keywords: 'о нас, компания, аренда, недвижимость, Тюмень, история компании, услуги',
    path: '/about',
  },
  privacy: {
    title: 'DomikTyumen - Политика конфиденциальности',
    description: 'Политика конфиденциальности компании DomikTyumen. Информация о том, как мы обрабатываем ваши персональные данные.',
    keywords: 'политика конфиденциальности, персональные данные, аренда, недвижимость, Тюмень',
    path: '/privacy',
  },
  terms: {
    title: 'DomikTyumen - Условия использования',
    description: 'Условия использования сервиса DomikTyumen. Правила и условия аренды недвижимости в Тюмени.',
    keywords: 'условия использования, правила, аренда, недвижимость, Тюмень',
    path: '/terms',
  },
  login: {
    title: 'DomikTyumen - Вход в личный кабинет',
    description: 'Вход в личный кабинет на сайте DomikTyumen. Управляйте своими бронированиями и настройками.',
    keywords: 'вход, логин, личный кабинет, аренда, недвижимость, Тюмень',
    path: '/login',
  },
  register: {
    title: 'DomikTyumen - Регистрация на сайте',
    description: 'Регистрация на сайте DomikTyumen. Создайте аккаунт для бронирования недвижимости в Тюмени.',
    keywords: 'регистрация, создать аккаунт, аренда, недвижимость, Тюмень',
    path: '/register',
  },
  notFound: {
    title: 'DomikTyumen - Страница не найдена',
    description: 'Запрашиваемая страница не найдена на сайте DomikTyumen.',
    keywords: 'страница не найдена, 404, аренда, недвижимость, Тюмень',
    path: '/404',
  },
};

/**
 * Generate canonical URL for a page
 * @param {string} path - Page path
 * @returns {string} Canonical URL
 */
export const getCanonicalUrl = (path) => {
  return `${BASE_URL}${path}`;
};

/**
 * Generate property specific SEO data
 * @param {Object} property - Property data
 * @returns {Object} SEO data for the property
 */
export const getPropertySEO = (property) => {
  if (!property) return DEFAULT_SEO;
  
  return {
    title: `${property.title} - Аренда в Тюмени | DomikTyumen`,
    description: property.description ? 
      `${property.description.substring(0, 150)}...` : 
      `Аренда ${property.type} в Тюмени. ${property.bedrooms} спальни, ${property.bathrooms} ванные комнаты. Забронируйте сейчас!`,
    keywords: `${property.title}, аренда, ${property.type}, Тюмень, ${property.location}, ${property.bedrooms} спальни`,
    ogImage: property.images && property.images.length > 0 ? property.images[0] : DEFAULT_SEO.ogImage,
    path: `/property/${property.id}`,
  };
};
